import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Box, Grid, Card, CardContent, CardActions, Paper, CircularProgress, Popover, Typography, Divider, MenuItem } from '@mui/material';
import client from '../common/client';


const Join = props => {
    const { screen_id, show_script = true } = useParams()
    const [blockId, setBlockId] = React.useState(null)
    const [value, setValue] = useState('');
    const [loadingScript, setLoadingScript] = useState(false);
    
    useEffect(() => {
        client.request_get(`/screen/${screen_id}`).then(res => {
            if (res && res.block_list) {
                setBlockId(res.block_list[0].block_id)
                setValue(res.javascript_on_create)
            } else
                ;//alert(JSON.stringify(res))
        })
    }, [])

    const handleChange = (code) => {
        setValue(code)
    }

    const handleSaveScreenSource = () => {
        setLoadingScript(true)
        client.request_post(`/api/learning/screen/${screen_id}`, {
            javascript_on_create: value
        }).then(res => {
            setLoadingScript(false)
        })
    }

    return (
        <Box m={0}>
            Member Join Ready
        </Box>
    );
};

export default Join;
